export default __webpack_public_path__ + "static/media/mai.bea26fd6.jpeg";